import { cn } from "src/common/utils";

const BuildkiteIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-1 flex items-center justify-center")}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 480 320" className="w-full h-full">
      <g clipPath="url(#a)">
        <path fill="#14CC80" d="M320 160v160l160-80V80l-160 80Z" />
        <path fill="#30F2A2" d="M320 0v160l160-80L320 0Z" />
        <path fill="#14CC80" d="M160 80v160l160-80V0L160 80Z" />
        <path fill="#30F2A2" d="M0 0v160l160 80V80L0 0Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h480v320H0z" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default BuildkiteIcon;
